export default __webpack_public_path__ + "static/banner-default-1a3bf36cab2613f3b3e2fd22f59a6065.jpg";